import { generateId } from "../../../utils";

export const normalTextElement = { type: 'p', children: [{ text: '' }] }

import { JsonNode, JsonEditor } from '../../../../SuperChargedRte/utils/types'
import { Node, Path, Transforms } from "slate";

export const getNormalTextElement = () => {
  return { type: 'p', uid: generateId(), attrs: {}, children: [{ text: '' }] }
}

export const removeDoubleParagraphs = (editor: JsonEditor, entry: [JsonNode, Path]) => {
  const [pNode, path] = entry

  if (pNode.children.length !== 1) return

  const child = Node.child(pNode, 0) as JsonNode
  if (!child) return

  if (child.type !== "p") return

  Transforms.unwrapNodes(editor, { at: path })

}